const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowSmallMenu', ['ShopPageStateService', '$timeout',
	'$state', 'SettingsService',
	'ShopperService', 'FeatureService', 'BreakpointsService',
	'GlobalHeaderPanelService', '$rootScope',
	'TrolleyService', 'AtmService', 'panelOverride', require('./small-format-menu-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/smallformatmenu/index.js
 **/